import { obtenerVentasPorPeriodo } from './ventas'
import { obtenerProductos } from './productos'
import { obtenerCliente } from './clientes'

// Retorna { ok: true } si se puede eliminar, o { ok: false, motivo: string } si no.

export async function puedeEliminarProducto(productoId) {
  const todas = await obtenerVentasPorPeriodo(null)
  const fiadosConProducto = todas.filter(v =>
    (v.tipo === 'venta' || !v.tipo) &&
    v.metodoPago === 'fiado' &&
    v.items?.some(i => i._id === productoId)
  )

  if (fiadosConProducto.length === 0) return { ok: true }

  // Verificar si algún cliente aún tiene deuda pendiente
  const clienteIds = [...new Set(fiadosConProducto.map(v => v.clienteId).filter(Boolean))]
  const clientes = await Promise.all(
    clienteIds.map(id => obtenerCliente(id).catch(() => null))
  )
  const conDeuda = clientes.filter(c => c && c.deuda > 0)

  if (conDeuda.length > 0) {
    const nombres = conDeuda.map(c => c.nombre).join(', ')
    return {
      ok: false,
      motivo: `${conDeuda.length === 1 ? 'El cliente' : 'Los clientes'} ${nombres} tiene${conDeuda.length > 1 ? 'n' : ''} fiados pendientes con este producto. Liquida la deuda antes de eliminarlo.`,
    }
  }

  return { ok: true }
}

export async function puedeEliminarCategoria(nombreCategoria) {
  const todos = await obtenerProductos()
  const asignados = todos.filter(p => p.categoria === nombreCategoria)

  if (asignados.length > 0) {
    return {
      ok: false,
      motivo: `${asignados.length} producto${asignados.length !== 1 ? 's' : ''} pertenece${asignados.length !== 1 ? 'n' : ''} a esta categoría. Reasígnalos antes de eliminarla.`,
    }
  }

  return { ok: true }
}
